const CONSTANTS = module.exports = {};

CONSTANTS.ISRAELI_VAT_INCLUDED_FACTOR_UNTIL_2024 = 1.17;
CONSTANTS.ISRAELI_VAT_INCLUDED_FACTOR_FROM_2025 = 1.18;
